/* eslint-disable class-methods-use-this */
import Utility from '@/common/UtilityFunctions.js';

export default class Ecommerce {
  constructor(vm) {
    this.vm = vm;
  }

  get(event) {
    let trackingObject = null;

    switch (event) {
      case 'checkout-steps':
        trackingObject = {
          event: 'checkout',
          ecommerce: {
            checkout: this.vm
          }
        };
        break;

      case 'confirmation-page':
        trackingObject = {
          event: 'purchase',
          ecommerce: this.vm
        };
        break;

      case 'product-add-to-cart':
        trackingObject = {
          ecommerce: {
            currencyCode: 'DKK',
            add: {
              products: [
                {
                  id: this.vm.vueModel.ProductType,
                  price: this.vm.vueModel.Coverage.YearlyPrice,
                  brand: Utility.getBrandIdentifier(),
                  quantity: 1
                }
              ]
            }
          },
          event: 'addToCart'
        };
        break;

      case 'product-remove-from-cart':
        trackingObject = {
          event: 'removeFromCart',
          ecommerce: {
            remove: {
              products: this.vm.products
            }
          }
        };
        break;

      case 'product-detail-view':
        trackingObject = {
          ecommerce: {
            detail: {
              products: this.vm.products
            }
          },
          event: 'detailView'
        };
        break;

      default:
        trackingObject = {};
    }

    return trackingObject;
  }
}
